<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { usePricePoliciesStore } from "~/stores/price-policies";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { pricePoliciesConfirmDelete } = useModalStore();
const pricePoliciesStore = usePricePoliciesStore();

const submitPricePolicyDelete = async () => {
	await pricePoliciesStore.deleteById(pricePoliciesConfirmDelete.pricePolicy.id);

	pricePoliciesConfirmDelete.closeModal();

	if (route.name === "price-policies-policy") {
		navigateTo("/price-policies");
	} else if (route.name === "price-policies") {
		pricePoliciesStore.getAll({}, pricePoliciesStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.PRICE_POLICIES.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.PRICE_POLICIES.CONFIRM_DELETE.alert.description", { pricePolicy: pricePoliciesConfirmDelete.pricePolicy.price }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.PRICE_POLICIES.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.PRICE_POLICIES.CONFIRM_DELETE.description', {pricePolicy: pricePoliciesConfirmDelete.pricePolicy.price})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="pricePoliciesConfirmDelete.closeModal"
		@submit="submitPricePolicyDelete"
	/>
</template>
